import { LocationState, Path } from 'history';
import { LinkProps } from 'react-router-dom';

export type BannerPayload = {
    type: 'error' | 'default' | 'warning';
    message: string;
    messageId?: string;
};

export type RedirectWithBannerPayload = {
    notify?: BannerPayload[];
};

export type NavigationPush = (
    to: Path,
    replace?: boolean,
    state?: LocationState | RedirectWithBannerPayload,
    preventScroll?: boolean
) => void;

export interface HybridLinkProps extends LinkProps {
    to: string;
    className?: string;
    isCurrentPage?: boolean;
    target?: string;
    isNavLink?: boolean;
    activeClassName?: string;
    testId?: string;
}

export enum PageType {
    LANDING = 'n',
    CATEGORY = 'category',
    BRANDS = 'brands',
    NEWPRODUCTS = 'new-products',
    ALLPRODUCTS = 'all-products',
    STYLES = 'styles', // obsolete PageType: every call to this page should lead to ALLPRODUCTS instead
    HOMEPAGE = 'homepage',
    PDP = 'PDP',
    LLP = 'LLP',
    LOOKS = 'looks',
    B2B = 'b2b',
    ALICE_OTHER = 'alice-other',
    ALICE_WISHLIST = 'alice-wishlist',
    ALICE_INTERIOR_DESIGN_SERVICE = 'alice-interior-design-service',
    ALICE_STATIC_PAGE = 'alice-static-page',
    EXTERNAL = 'external',
    CART = 'cart',
    CART_NATIVE = 'cart-native',
    ALICE_CART = 'alice-cart',
    UNKNOWN = 'unknown',
    LOOKS_WISHLIST = 'wishlist',
    WISHLIST_NATIVE = 'wishlist-native',
    INTERIOR_DESIGN_SERVICE = 'interior-design-service',
    INTERIOR_DESIGN_SERVICE_FORM = 'interior-design-service-form',
    INTERIOR_DESIGN_SERVICE_NATIVE = 'interior-design-service-native',
    CHECKOUT = 'checkout',
    CHECKOUT_NATIVE = 'checkout-native',
    ASSEMBLYSERVICE = 'assemblyservice-app-webview',
    SHIPPING_INFO = 'shippingfee-app-webview',
    CLUB_UPCOMING_CAMPAIGN = 'club-upcoming-campaign',
    CLUB_PDP = 'club-product-detail',
    CLUB_SERVICE_PAGE = 'club-service-page',
}

export enum CheckoutPathType {
    REDIRECT = '/shop/checkout/',
    LOGIN = '/shop/checkout/login/',
    ADDRESS = '/shop/checkout/address/',
    PAYMENT = '/secure/checkout/payment/',
    ORDER_SUCCESS = '/shop/checkout/success/',
    ORDER_CONFIRMATION = '/shop/checkout/confirmation/',
    APP_REDIRECT = '/app/shop/checkout/',
    APP_LOGIN = '/app/shop/checkout/login/',
    APP_ADDRESS = '/app/shop/checkout/address/',
    APP_PAYMENT = '/app/secure/checkout/payment/',
    APP_ORDER_SUCCESS = '/app/shop/checkout/success/',
    APP_ORDER_CONFIRMATION = '/app/shop/checkout/confirmation/',
}

export interface PageTypeResult {
    pageType: PageType;
    relativeUrl?: string;
}

export type Route =
    | 'ALICE_CART'
    | 'ALICE_CHECKOUT'
    | 'CART'
    | 'CART_NATIVE'
    | 'CHECKOUT'
    | 'CHECKOUT_PAYMENT'
    | 'CHECKOUT_NATIVE'
    | 'LOOKS_WISHLIST'
    | 'WISHLIST_NATIVE'
    | 'ASSEMBLYSERVICE'
    | 'SHIPPING_INFO'
    | 'INTERIOR_DESIGN_SERVICE'
    | 'INTERIOR_DESIGN_SERVICE_NATIVE'
    | 'INTERIOR_DESIGN_SERVICE_OLD'
    | 'HALLO_WELT'
    | 'LOOKS'
    | 'B2B'
    | 'SERVICE_PAGE'
    | 'OOPS_PAGE'
    | 'STYLES'
    | 'ALL_PRODUCTS'
    | 'CLUB_MF_ROOT'
    | 'CLUB_MF_PRODUCT_DETAIL_PAGE'
    | 'CLUB_MF_UPCOMING_CAMPAIGN_PAGE'
    | 'CLUB_MF_SERVICE_PAGE'
    | 'LOGIN_AND_REGISTRATION' // TODO[P100-3667]: only for dev/review, should be removed
    | 'RESET_PASSWORD';
